import { Link } from "react-router-dom"
import Marquee from "react-fast-marquee"

export function TopnavMarquee() {
  return (
    <Link to="/scroll">
      <button
        className="
          hidden lg:flex
          items-center
          h-9
          w-[20rem]
          xl:w-[25rem]
          overflow-hidden
          rounded-xl
          bg-white/5
          border border-white/20
          backdrop-blur-xl
        "
      >
        <Marquee
          gradient={false}
          speed={30}
        >
          <span
            className="
              text-lg
              font-black
              tracking-wide
              text-transparent
              bg-clip-text
              bg-gradient-to-r
              from-white
              via-pink-300
              to-purple-300
            ">
            &nbsp; MIXTAPE RADIO &nbsp;
            STREAM DJS &nbsp;
            BASS MUSIC • DNB • DUBSTEP •
            URBAN &nbsp;
          </span>
        </Marquee>
      </button>
    </Link>
  )
}